import React from 'react';

import DashboardIcon from '@material-ui/icons/Dashboard';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';

import {
  PERMISSAO_TELA_DASHBOARD_LISTAR,
  PERMISSAO_TELA_SESSOES_LISTAR,
  PERMISSAO_TELA_CONTAS_LISTAR,
  PERMISSAO_TELA_CAIXAS_LISTAR,
  PERMISSAO_TELA_CONTAS_TABELA_LISTAR,
  PERMISSAO_TELA_VERIFICACAO_NOTAS_VENDAS_LISTAR,
  PERMISSAO_TELA_CARTOES_CREDITO_LISTAR,
  PERMISSAO_TELA_TRANSACOES_LISTAR,
  PERMISSAO_TELA_TRANSACOES_CONFERENCIA_LISTAR,
  PERMISSAO_TELA_PIX_LISTAR,
  PERMISSAO_TELA_TRANSFERENCIAS_LISTAR,
  PERMISSAO_TELA_AJUSTES_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_TRANSACOES_LISTAR,
  PERMISSAO_TELA_FUTUROLOGIA_LISTAR,
  PERMISSAO_TELA_TRANSACOES_SIMULADAS_LISTAR,
  PERMISSAO_TELA_VENDAS_FATURADAS_LISTAR,
  PERMISSAO_TELA_AGENDAMENTOS_LISTAR,
  PERMISSAO_TELA_CONFERENCIAS_MAQUINETAS_LISTAR,
  PERMISSAO_TELA_IMPOSTOS_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';
import StyledMenuItemLink from './StyledMenuItemLink';

const SubMenuFinanceiro = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Financeiro"
    icon={<MonetizationOnIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_DASHBOARD_LISTAR] && (
      <StyledMenuItemLink
        key="dashboard_contabilidade"
        to="/dashboard-contabilidade"
        primaryText="Dashboard"
        leftIcon={<DashboardIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_SESSOES_LISTAR] && hasResource('sessoes')}
    {permissoes[PERMISSAO_TELA_CONTAS_LISTAR] && hasResource('contas')}
    {permissoes[PERMISSAO_TELA_CAIXAS_LISTAR] && hasResource('caixas_fc')}
    {permissoes[PERMISSAO_TELA_CONTAS_TABELA_LISTAR] &&
      hasResource('contas_tabela')}
    {permissoes[PERMISSAO_TELA_VERIFICACAO_NOTAS_VENDAS_LISTAR] &&
      hasResource('parcelas_vendas_nfe_verificado')}
    {permissoes[PERMISSAO_TELA_CARTOES_CREDITO_LISTAR] &&
      hasResource('cartoes_credito')}
    {permissoes[PERMISSAO_TELA_TRANSACOES_LISTAR] && hasResource('transacoes')}
    {permissoes[PERMISSAO_TELA_TRANSACOES_CONFERENCIA_LISTAR] &&
      hasResource('transacoes_limpas')}
    {permissoes[PERMISSAO_TELA_PIX_LISTAR] && hasResource('transacoes_pix')}
    {permissoes[PERMISSAO_TELA_TRANSFERENCIAS_LISTAR] &&
      hasResource('financeiro_tela_transferencias')}
    {permissoes[PERMISSAO_TELA_AJUSTES_LISTAR] &&
      hasResource('financeiro_tela_reajustes')}
    {permissoes[PERMISSAO_TELA_CATEGORIAS_TRANSACOES_LISTAR] &&
      hasResource('categorias_transacao_cards')}
    {permissoes[PERMISSAO_TELA_FUTUROLOGIA_LISTAR] && (
      <StyledMenuItemLink
        key="tela_futurologia"
        to="/tela_futurologia"
        primaryText="Futurologia"
        leftIcon={<ImportExportIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_TRANSACOES_SIMULADAS_LISTAR] &&
      hasResource('transacoes_simuladas')}
    {permissoes[PERMISSAO_TELA_VENDAS_FATURADAS_LISTAR] && (
      <StyledMenuItemLink
        key="vendas_faturadas"
        to="/vendas_faturadas"
        primaryText="Vendas Faturadas"
        leftIcon={<ImportExportIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_AGENDAMENTOS_LISTAR] && (
      <StyledMenuItemLink
        key="despesas_agendadas"
        to="/despesas_agendadas"
        primaryText="Agendamentos"
        leftIcon={<ImportExportIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_CONFERENCIAS_MAQUINETAS_LISTAR] &&
      hasResource('transacoes_conferencia_get_net')}
    {permissoes[PERMISSAO_TELA_IMPOSTOS_LISTAR] &&
      hasResource('contas_especiais')}
  </SubMenu>
);

export default SubMenuFinanceiro;
